/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import {
  Table,
  TableHead,
  Row,
  NormalTableHeader,
  MediumTableHeader,
  SmallTableHeader,
  TableBody,
  NormalTableCell,
  MediumTableCell,
  SmallTableCell,
  Icon,
  ScrollWrapper,
  MyPaginate,
  PaginateButton,
  IconWrapper,
} from './nftsTableElements';
import useTable from '../../../Hooks/useTable';
import useDeviceDetect from '../../../Hooks/checkDevice';
import Popup from '../../popup/popup';
import EditNftsPopup from '../../popup/editNfts';

const NftsTable = ({
  data, setData, rowsPerPage,
}) => {
  const { isMobile } = useDeviceDetect();

  const [page, setPage] = useState(1);
  const { slice, range } = useTable(data, page, rowsPerPage);

  const [editOpen, setEditOpen] = useState(false);
  const [selected, setSelected] = useState({});

  return (
    <>
      <Popup header="Edit NFT" trigger={editOpen} setOpen={setEditOpen}>
        <EditNftsPopup
          setOpen={setEditOpen}
          trigger={editOpen}
          selected={selected}
          setData={setData}
          data={data}
        />
      </Popup>
      <ScrollWrapper>
        <Table>
          <TableHead>
            <Row>
              <SmallTableHeader>NFT_ID</SmallTableHeader>
              <NormalTableHeader>Wallet</NormalTableHeader>
              <NormalTableHeader>Email</NormalTableHeader>
              <NormalTableHeader>Prev owner</NormalTableHeader>
              <MediumTableHeader>Hectare</MediumTableHeader>
              <MediumTableHeader>Mint date</MediumTableHeader>
              <MediumTableHeader>Exp date</MediumTableHeader>
              <SmallTableHeader>Action</SmallTableHeader>
            </Row>
          </TableHead>
          <TableBody>
            {slice.map((item, index) => (
              <Row dark={index % 2 === 1} key={item.NFT_ID}>
                <SmallTableCell data-label="NFT_ID">{item.NFT_ID}</SmallTableCell>
                <NormalTableCell data-label="Wallet">{item.Wallet_Address}</NormalTableCell>
                <NormalTableCell data-label="Email">{item.Email}</NormalTableCell>
                <NormalTableCell data-label="PrevOwner">{item.Previous_Owner}</NormalTableCell>
                <MediumTableCell data-label="Hectare">{item.Hectare}</MediumTableCell>
                <MediumTableCell data-label="MintDate">{(item.Mint_Date).split('T')[0]}</MediumTableCell>
                <MediumTableCell data-label="ExpDate">{(item.Exp_Date).split('T')[0]}</MediumTableCell>
                <SmallTableCell>
                  <IconWrapper>
                    <Icon
                      edit
                      onClick={() => { setEditOpen(true); setSelected(item); }}
                    >
                      <AiFillEdit />
                    </Icon>
                  </IconWrapper>
                </SmallTableCell>
              </Row>
            ))}
          </TableBody>
        </Table>
      </ScrollWrapper>
      <MyPaginate
        breakLabel={isMobile ? '' : '...'}
        onPageChange={(e) => setPage((e.selected) + 1)}
        pageRangeDisplayed={isMobile ? 1 : 2}
        marginPagesDisplayed={isMobile ? 1 : 2}
        pageCount={range.length}
        renderOnZeroPageCount={null}
        nextLabel={(
          <PaginateButton>
            <MdArrowForward />
          </PaginateButton>
        )}
        previousLabel={(
          <PaginateButton>
            <MdArrowBack />
          </PaginateButton>
        )}
      />
    </>
  );
};

export default NftsTable;
